var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ready
    ? _c(
        "div",
        { class: { scrolled: _vm.scrolled } },
        [
          _c("notice-turn"),
          _vm._v(" "),
          _c("the-header"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main", class: _vm.routeName },
            [_c("router-view")],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }